/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_AppreciationInputs */

const cs_investor_appreciation = /** @type {(inputs: Investor_AppreciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciál zhodnocení`)
};

const en_investor_appreciation = /** @type {(inputs: Investor_AppreciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appreciation potential`)
};

/**
* | output |
* | --- |
* | "Appreciation potential" |
*
* @param {Investor_AppreciationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_appreciation = /** @type {((inputs?: Investor_AppreciationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_AppreciationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_appreciation(inputs)
	return cs_investor_appreciation(inputs)
});